<template>
  <div style="background: #fff" v-if="detailsData">
    <headers />
    <div class="head">
      <img src="@/assets/images/communityBj.png" />
      <div class="headTit">盘厂详情</div>
    </div>
    <div class="content">
      <!-- 联盟公司信息 -->
      <div class="contentGsInfo">
        <div class="infoLeft flexCenter">
          <img v-if="detailsData.image" :src="detailsData.image" alt="" />
          <div v-else class="cardImgTextBox MyCustomFont">
            <div>{{ detailsData.abbr }}</div>
          </div>
        </div>
        <div class="infoRight">
          <div class="rightTit">{{ detailsData.name }}</div>
          <div class="cardRIcon">
            <div
              class="cardRIconImte"
              v-if="detailsData.equityClassifyNames.includes('L1')"
            >
              <img src="@/assets/images/L1.png" />
              L1级授权合作伙伴
            </div>
            <div
              class="cardRIconImte"
              v-if="detailsData.equityClassifyNames.includes('L2')"
            >
              <img src="@/assets/images/L2.png" />
              L2级授权合作伙伴
            </div>
            <div
              class="cardRIconImte"
              v-if="detailsData.equityClassifyNames.includes('L3')"
            >
              <img src="@/assets/images/L3.png" />
              L3级授权合作伙伴
            </div>
            <div
              class="cardRIconImte"
              v-if="detailsData.equityClassifyNames.includes('L4')"
            >
              <img src="@/assets/images/L4.png" />
              L4级授权合作伙伴
            </div>
          </div>

          <div class="rightAddress">
            <div class="addressLeft">
              <img src="@/assets/images/address.png" />
              <div>所在地：</div>
              <div>{{ detailsData.address }}</div>
            </div>
            <div class="addressLeft" v-if="detailsData.rebateCompleteRate">
              <img src="@/assets/images/fdIcon.png" />
              <div>返点完成率：</div>
              <div>{{ detailsData.rebateCompleteRate }}%</div>
            </div>
          </div>

          <div class="addressLeft" v-if="detailsData.purchaseOrderAmount">
            <img src="@/assets/images/priceIcon.png" />
            <div>采购下单金额：</div>
            <div style="color: #00d8c3">
              ¥{{ detailsData.purchaseOrderAmount }}
            </div>
          </div>
        </div>
      </div>

      <div class="headBox">
        <div
          class="headItem"
          :class="[i.id !== tabAct && 'noHead']"
          v-for="i in headTabList"
          :key="i.id"
          @click="tabChange(i.id)"
        >
          {{ i.title }}
        </div>
      </div>
      <template v-if="tabAct === 1">
        <div
          class="card"
          v-for="(item, index) in detailsData.projects"
          :key="index"
        >
          <div class="cardTit">{{ item.projectName }}</div>
          <div class="cardBox">
            <div class="cardBoxLeft">
              <img src="@/assets/images/rqIcon.png" alt="" />
              <div>{{ item.projectDate }}</div>
            </div>
            <div class="cardBoxLeft">
              <img src="@/assets/images/priceIcon.png" alt="" />
              <div style="color: #00d8c3">¥{{ item.projectAmount }}</div>
            </div>
          </div>
        </div>
        <!-- <div class="page" v-if="list.length">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="pages.total"
            :current-page="pages.page"
            :page-size="pages.size"
            @current-change="currentChange"
          >
          </el-pagination>
        </div> -->

        <None v-if="!detailsData.projects.length" />
      </template>

      <template v-if="tabAct === 0">
        <div v-html="detailsData.details" style="margin-top: 30px"></div>
        <!-- 视频区域 -->
        <div v-if="detailsData.video && detailsData.video.length">
          <div
            class="video videoBox"
            style="position: relative"
            v-for="(item, index) in detailsData.video"
            :key="index"
          >
            <video
              class="video"
              muted
              preload
              :ref="
                (el) => {
                  if (el) videoRefs[index] = el;
                }
              "
              @play="onPlay(index)"
              @pause="onPause(index)"
              controls
            >
              <source :src="item" type="video/mp4" />
            </video>
            <img
              v-if="showBtn[index]"
              @click="togglePlay(index)"
              class="playIcon"
              src="@/assets/images/play.png"
            />
          </div>
        </div>
      </template>
    </div>

    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import search from "@/components/search.vue";
import { factoryList, getFactoryDetails } from "@/api/lx";
export default {
  name: "Procucts",
  components: {
    headers,
    footers,
    search,
  },
  data() {
    return {
      headTabList: [
        {
          title: "详情",
          id: 0,
        },
        {
          title: "项目",
          id: 1,
        },
      ],
      tabAct: 0,
      pages: {
        page: 1,
        total: 0,
        size: 10,
      },
      content: "测试",
      detailsData: null,
      showBtn: {},
      videoRefs: [],
    };
  },
  created() {
    this.getFactoryDetails();
  },
  mounted() {},
  methods: {
    async getFactoryDetails() {
      const res = await getFactoryDetails(this.$route.query.id);
      if (res.code == 200) {
        let newData = {
          ...res.data,
          video: res.data.video
            ? res.data.video.split(",").filter((item) => item.trim())
            : [],
        };
        console.log(newData, "newDatanewDatanewData");
        // 初始化所有视频的播放按钮状态为false
        newData.video.forEach((_, index) => {
          this.$set(this.showBtn, index, true);
        });

        console.log(this.showBtn, "this.showBtn");

        if (newData.details) {
          newData.details = newData.details.replace(/<img[^>]*>/g, (match) =>
            match.replace(/style="[^"]*"/, 'style="width: 100%!important;"')
          );
        }
        this.detailsData = newData;
      }
    },
    tabChange(id) {
      this.tabAct = id;
    },
    currentChange(val) {
      this.pages.page = val;
      this.getList();
    },
    searchFun(val) {
      this.searchValue = val;
      this.pages.page = 1;
      this.getList();
    },
    // getList() {
    //   factoryList({
    //     page: this.pages.page,
    //     size: this.pages.size,
    //     name: this.searchValue,
    //   }).then((res) => {
    //     this.list = res.data.records;
    //     this.pages.total = res.data.total;
    //   });
    // },
    toSolutionDetails() {
      this.$router.push({
        path: "/forum/details",
        query: { id: 123 },
      });
    },
    onPlay(index) {
      // 暂停其他所有视频
      this.videoRefs.forEach((video, i) => {
        if (i !== index && video) {
          video.pause();
          this.$set(this.showBtn, i, true);
        }
      });
      this.$set(this.showBtn, index, false);
    },
    onPause(index) {
      this.$set(this.showBtn, index, true);
    },
    togglePlay(index) {
      // 暂停其他所有视频
      this.videoRefs.forEach((video, i) => {
        if (i !== index && video) {
          video.pause();
          this.$set(this.showBtn, i, true);
        }
      });
      const video = this.videoRefs[index];
      if (video) {
        video.play();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  width: 100%;
  height: 240px;
  position: relative;
  overflow: hidden;
  .headTit {
    width: 100%;
    text-align: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 42px;
    color: #ffffff;
    position: relative;
    z-index: 1;
    margin-top: 90px;
  }
  .searchBox {
    margin-top: 54px;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.content {
  width: 100%;
  padding: 0 260px;
  box-sizing: border-box;
  margin-top: 30px;
  .headBox {
    width: 1400px;
    height: 48px;
    display: flex;
    background: #f3f3f3;
    .headItem {
      cursor: pointer;
      width: 161px;
      height: 48px;
      background: #ffffff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #00161a;
      text-align: center;
      line-height: 48px;
      box-sizing: border-box;
      border-bottom: 3px solid #00d8c3;
    }

    .noHead {
      border: none;
      background: #f3f3f3;
      color: #525f66;
    }
  }
  .card {
    width: 1400px;
    background-color: #f9f9f9;
    margin-top: 30px;
    padding: 25px 30px;
    border-top: 5px solid #00d8c3;
    .cardTit {
      margin-bottom: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 18px;
      color: #00161a;
      line-height: 28px;
    }
    .cardBox {
      display: flex;
      align-items: center;

      .cardBoxLeft {
        display: flex;
        align-items: center;
        margin-right: 40px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #525f66;
        img {
          width: 14px;
          height: 14px;
          margin-right: 4px;
        }
      }
    }
  }
}
.cardRIcon {
  display: flex;
  margin-top: 9px;
  .cardRIconImte {
    display: flex;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #525f66;
    margin-right: 15px;
    img {
      width: 44px;
      height: 32px;
      margin-right: 15px;
    }
  }
}
.page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 65px;
}

.tabBox {
  display: flex;
  margin-top: 20px;
  margin-bottom: 30px;
  margin-left: 45px;
  cursor: pointer;
  .tabItem {
    padding: 0 18px;
    height: 32px;
    line-height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #525f66;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #e6edf0;
    margin-right: 20px;
  }
  .tabItemAct {
    padding: 0 18px;
    height: 32px;
    line-height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    background: #00d8c3;
    border-radius: 16px;
    border: 1px solid #00d8c3;
    margin-right: 20px;
  }
}

.contentGsInfo {
  background: #f9f9f9;
  padding: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  .infoRight {
    height: 148px;
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .rightTit {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 24px;
      color: #00161a;
      line-height: 28px;
      text-align: left;
    }

    .rightAddress {
      display: flex;
      align-items: center;
    }
    .addressLeft {
      margin-right: 30px;
      display: flex;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #525f66;
      img {
        margin-right: 4px;
        width: 14px;
        height: 14px;
      }
    }
  }
  .infoLeft {
    width: 148px;
    height: 148px;
    margin-right: 20px;
    background: #ffffff;
    border: 1px solid #e6edf0;

    .cardImgTextBox {
      width: 100%;
      height: 100%;
      font-size: 34px;
      background-color: #00d8c3;
      padding: 20px;
      box-sizing: border-box;
      color: #fff;
      word-break: break-all;
      display: flex;
      align-items: center;
      justify-content: center;
      div {
        text-align: center;
      }
    }
    img {
      width: 123px;
      height: 123px;
    }
  }
}

div {
  box-sizing: border-box;
}
.videoBox {
  margin-top: 20px;
}
.video {
  width: 100%;
  height: 697px;
  // margin-top: 20px;
  // margin-bottom: 20px;
  background-color: #00161a;
}
.playIcon {
  position: absolute;
  width: 120px;
  height: 120px;
  top: 304px;
  left: 588px;
  cursor: pointer;
}
img {
  width: 100%;
  height: 100%;
}
</style>
